import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { Component } from '@angular/core';
import { PaymentRequestStep } from '@dato-proxy/entities/paymentrequest.entity';

@Component({
    providers: ServiceBagServices,
    selector: 'app-payment-request-step-grid',
    templateUrl: './payment-request-step-grid.component.html',
    styleUrls: ['./payment-request-step-grid.component.scss']
})
export class PaymentRequestStepGridComponent extends BaseGridComponent<PaymentRequestStep, BaseState> {

    constructor(A: ServiceBagService) {
        super(A, 'PaymentRequestStepGridComponent', PaymentRequestStep, BaseState);
    }


}
